import React from "react";
import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-white/10 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
          <div className="md:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_fullcircle-mma/artifacts/hpytiapw_Copilot_20260501_123104.png"
              alt="Full Circle MMA"
              className="h-14 w-auto"
            />
            <p className="mt-5 text-white/60 max-w-sm leading-relaxed">
              Wollongong's home for honest MMA training. Striking, grappling and
              everything in between — built for fighters, open to everyone.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-[#d4af37] font-bold">
              Visit
            </div>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[#d4af37] shrink-0" />
                16 Waynote Place,<br />Unanderra NSW
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#d4af37]" />
                —
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[#d4af37]" />
                —
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.25em] text-[#d4af37] font-bold">
              Train
            </div>
            <ul className="mt-5 space-y-2 text-sm text-white/70">
              <li><a href="#training" className="hover:text-[#d4af37]">Striking</a></li>
              <li><a href="#training" className="hover:text-[#d4af37]">Grappling</a></li>
              <li><a href="#timetable" className="hover:text-[#d4af37]">Timetable</a></li>
              <li><a href="#membership" className="hover:text-[#d4af37]">Memberships</a></li>
              <li><a href="#booking" className="hover:text-[#d4af37]">Private</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.25em] text-[#d4af37] font-bold">
              Follow
            </div>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#"
                data-testid="social-instagram"
                aria-label="Instagram"
                className="w-10 h-10 border border-white/15 flex items-center justify-center hover:border-[#d4af37] hover:text-[#d4af37]"
              >
                <Instagram size={16} />
              </a>
              <a
                href="#"
                data-testid="social-facebook"
                aria-label="Facebook"
                className="w-10 h-10 border border-white/15 flex items-center justify-center hover:border-[#d4af37] hover:text-[#d4af37]"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.2em] text-white/40">
          <div>© {new Date().getFullYear()} Full Circle MMA · Wollongong NSW</div>
          <div>Built for fighters. Open to everyone.</div>
        </div>
      </div>
    </footer>
  );
}
